var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2661 36.7158L11.2046 31.479L5.12183 30.2302L5.80664 24.3086L1.93945 19.7969L5.80664 15.3254L5.12183 9.40381L11.2046 8.15503L14.2661 2.87793L19.6641 5.37549L25.062 2.87793L28.1638 8.15503L34.2063 9.40381L33.5215 15.3254L37.3887 19.7969L33.5215 24.3086L34.2063 30.2302L28.1638 31.479L25.062 36.7158L19.6641 34.2183L14.2661 36.7158ZM17.9319 25.1545L27.0762 16.0908L25.2634 14.4392L17.9319 21.6902L14.105 17.7021L12.252 19.5149L17.9319 25.1545Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.be7ee6d82bb5705bae61b0caf33764db.svg";
export { ForwardRef as ReactComponent };